import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {
    Aangifte, BokkzAlgDataService,
    Gift, IncomeTaxEntity,
    PGAAftrekbareGiften
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-gewone-giften',
  templateUrl: './gewone-giften.component.html',
  styleUrls: ['./gewone-giften.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class GewoneGiftenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    private incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public anbiOptionsNaam: SelectFormControlItem<string>[] = [];
    public anbiOptionsPlaats: SelectFormControlItem<string>[] = [];

    @Input() searchResults: any[] = [];
    @Input() searchPerformed: boolean = false;
    @Input() resultCount: number = 0;

    @Output() updateSearchResults = new EventEmitter<{
        results: any[];
        performed: boolean;
        count: number;
    }>();

    public isDefAangifte = {} as boolean;

    public showAnbiSearch = false;
    public showSearchSpinner = false
    public showResult = false;

    public gewoneGiftenFg = {} as FormGroup

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"},
    ]

    public formGroup = this.fb.group({
        test: [''],
    });

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.gewoneGiftenFg = this.fb.group({
            gewoneGiften:
                this.fb.array<PGAAftrekbareGiften>([]),
            zoekWaardeNaam: [''],
            zoekWaardePlaats: ['']
        })
    }

    searchAnbi() {
        const query = {
            "search": [
                {
                    "zoekWaarde": this.gewoneGiftenFg.get('zoekWaardeNaam')?.value,
                    "zoekOpdrachtType": "INSTELLINGSNAAM"
                },
                {
                    "zoekWaarde": this.gewoneGiftenFg.get('zoekWaardePlaats')?.value,
                    "zoekOpdrachtType": "VESTIGINGSPLAATS"
                }
            ]
        };

        this.dataService.searchAnbi(query).subscribe(
            (response: any[]) => {
                this.searchPerformed = true
                this.resultCount = response.length;
                console.log('response', response)

                this.updateSearchResults.emit({
                    results: response,
                    performed: true,
                    count: response.length,
                });

                this.anbiOptionsNaam = response.map(anbi => ({
                    value: anbi.naam + ', ' + anbi.vestigingsPlaats + (anbi.ingangsDatumCultuur !== undefined ? (' (CULTURELE ANBI)') : ''),
                    label: anbi.naam + ', ' + anbi.vestigingsPlaats + (anbi.ingangsDatumCultuur !== undefined ? (' (CULTURELE ANBI)') : ''),
                    ingangsDatum: anbi.ingangsDatum,
                    ingangsdatumCultuur: anbi.ingangsDatumCultuur,
                    einddatumCultuur: anbi.eindDatumCultuur,
                    intrekkingsDatumCultuur: anbi.intrekkingsDatumCultuur,
                    fiscaalNummer: anbi.fiscaalNummer
                }));
                this.anbiOptionsPlaats = response.map(anbi => ({
                    value: anbi.naam + ', ' + anbi.vestigingsPlaats + (anbi.ingangsDatumCultuur !== undefined ? (' (CULTURELE ANBI)') : ''),
                    label: anbi.naam + ', ' + anbi.vestigingsPlaats + (anbi.ingangsDatumCultuur !== undefined ? (' (CULTURELE ANBI)') : ''),
                    ingangsDatum: anbi.ingangsDatum,
                    ingangsDatumCultuur: anbi.ingangsDatumCultuur,
                    eindDatumCultuur: anbi.eindDatumCultuur,
                    intrekkingsDatumCultuur: anbi.intrekkingsDatumCultuur,
                    fiscaalNummer: anbi.fiscaalNummer
                }));
            },
            (error) => {
                console.error('Error:', error);
            }
        );

    }

    get gewoneGiften(): FormArray {
        return this.gewoneGiftenFg.get('gewoneGiften') as FormArray;
    }

    addRijGewoneGiften(): void {
        this.gewoneGiften.push(this.createGewoneGiftenFormGroup())
        this.showAnbiSearch = true
    }

    verwijderRijGewoneGiften(index: number): void {
        this.gewoneGiften.removeAt(index);
        this.gewoneGiftenFg.updateValueAndValidity()
        this.gewoneGiftenFg.markAsDirty()
        this.saveForm()
    }

    createGewoneGiftenFormGroup(gift?: Gift): FormGroup {
        return this.fb.group(({
            omschrijving: gift ? gift.omschrijving : undefined,
            bedrag: gift ? gift.bedrag : undefined,
            cultureleAnbi: gift ? gift.cultureleAnbi : false
        } as Gift))
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        })
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        })
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe(); // Unsubscribe from income tax entity
        }

    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.gewoneGiftenFg.dirty;
    }

    public updateForm(): void {
        const gewoneGiftenLijst = this.aangifte?.persoonsgebondenAftrek?.pgaAftrekbareGiften?.gewoneGiften || [];
        const formArray = this.gewoneGiftenFg.get('gewoneGiften') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > gewoneGiftenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < gewoneGiftenLijst.length; i++) {
            if (formArray && i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(gewoneGiftenLijst[i]);
            } else {
                const formGroup = this.createGewoneGiftenFormGroup(gewoneGiftenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        const gewoneGiften = (this.gewoneGiftenFg.value.gewoneGiften as Gift[])
            .map(gift => ({
                ...gift,
                bedrag: gift.omschrijving?.trim() && !gift.bedrag ? 0 : gift.bedrag
            }));

        this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            persoonsgebondenAftrek: {
                ...this.aangifte.persoonsgebondenAftrek,
                pgaAftrekbareGiften: {
                    ...this.aangifte.persoonsgebondenAftrek?.pgaAftrekbareGiften,
                    gewoneGiften: gewoneGiften
                }
            }
        } as Aangifte;
        this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }

    tonenSpinner() {
        this.showSearchSpinner = true
        this.showResult = true
        setTimeout(() => {
            this.showSearchSpinner = false;
        }, 1000);
    }

    capitalizeWords(text: string): string {
        if (!text) return '';

        const exception = 'culturele anbi'; // De combinatie die lowercase moet blijven
        const exceptionLower = exception.toLowerCase();

        return text
            .split(new RegExp(`(${exception})`, 'i')) // Splits tekst rond de uitzondering (case-insensitive)
            .map(part => {
                // Behoud de uitzondering in lowercase
                if (part.toLowerCase() === exceptionLower) {
                    return exceptionLower;
                }

                // Pas hoofdlettertransformatie toe op andere delen
                return part
                    .split(' ')
                    .map(word => {
                        // Speciale behandeling voor woorden die beginnen met 's-
                        if (word.toLowerCase().startsWith("'s-")) {
                            // Vind de eerste letter na 's-
                            const prefix = "'s-";
                            return (
                                prefix +
                                word.charAt(prefix.length).toUpperCase() +
                                word.slice(prefix.length + 1).toLowerCase()
                            );
                        }
                        // Standaard hoofdlettertransformatie
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    })
                    .join(' ');
            })
            .join('');
    }
}
